var _defs, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoKartrak(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    zoomAndPan: "magnify",
    viewBox: "0 0 384 383.999986",
    height: 512,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "d4bc2cc433"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 222 16 L 368 16 L 368 161.957031 L 222 161.957031 Z M 222 16 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "165233059b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 222.875 16.300781 C 262.875 16.300781 299.058594 32.5 325.265625 58.710938 C 351.476562 84.917969 367.710938 121.136719 367.710938 161.132812 L 336.121094 161.132812 C 336.121094 129.871094 323.441406 101.542969 302.9375 81.039062 C 282.433594 60.535156 254.136719 47.886719 222.875 47.886719 Z M 222.875 16.300781 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7093b77b5d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 16 222 L 162 222 L 162 368 L 16 368 Z M 16 222 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "17400c5d60"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 161.132812 367.613281 C 121.136719 367.613281 84.917969 351.410156 58.710938 325.203125 C 32.5 298.992188 16.300781 262.777344 16.300781 222.777344 L 47.886719 222.777344 C 47.886719 254.039062 60.566406 282.367188 81.074219 302.871094 C 101.578125 323.375 129.871094 336.058594 161.167969 336.058594 Z M 161.132812 367.613281 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f8cdf02f46"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 134 52 L 274.5 52 L 274.5 286 L 134 286 Z M 134 52 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cb25d8495f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 171.304688 189.917969 L 186.039062 174.433594 C 191.253906 168.925781 196.375 163.382812 201.394531 157.875 L 215.703125 141.933594 C 220.234375 136.816406 224.082031 132.351562 227.277344 128.535156 L 270.304688 128.535156 C 260.265625 139.78125 249.738281 151.417969 238.621094 163.449219 L 205.140625 198.65625 C 211.171875 203.675781 217.433594 209.738281 224.050781 216.878906 L 243.25 239.597656 C 249.476562 247.617188 255.277344 255.636719 260.722656 263.6875 C 266.101562 271.707031 270.601562 279.140625 274.21875 285.953125 L 232.101562 285.953125 C 228.484375 279.726562 224.308594 273.207031 219.617188 266.394531 L 204.390625 246.507812 C 198.980469 240.085938 193.472656 234.023438 187.832031 228.285156 C 182.191406 222.550781 176.683594 217.691406 171.273438 213.683594 L 171.273438 285.921875 L 134.859375 285.921875 L 134.859375 85.960938 C 134.859375 83.777344 136.132812 58.285156 152.496094 55.484375 L 171.273438 52.386719 Z M 171.304688 189.917969 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d4bc2cc433)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#165233059b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00ad4c",
    d: "M 0 0 L 384 0 L 384 383.902344 L 0 383.902344 Z M 0 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7093b77b5d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#17400c5d60)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00ad4c",
    d: "M 0 0 L 384 0 L 384 383.902344 L 0 383.902344 Z M 0 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f8cdf02f46)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cb25d8495f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#232d46",
    d: "M 0 0 L 384 0 L 384 383.902344 L 0 383.902344 Z M 0 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoKartrak);
export default __webpack_public_path__ + "static/media/logo_kartrak.d93328f05f44a241f23e2d5b82776dce.svg";
export { ForwardRef as ReactComponent };